import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Grid,
  Segment,
  Pagination,
  Header,
} from 'semantic-ui-react';
import Input from './../../input/inputWithLabel';
import LoaderModal from './../loaderModal';
// import { ucwords } from '../../genericFunction/convertWord';
import Card from './card';
import styles from '../styles';

class listCard extends Component {
  static propTypes = {
    data: PropTypes.array,
    location: PropTypes.string,
    activePage: PropTypes.number,
    pageChange: PropTypes.func,
    searchName: PropTypes.string,
    handleChange: PropTypes.func,
    loading: PropTypes.bool,
    setExcursion: PropTypes.func,
  };

  pagination = (data, perPage) => {
    let sets = [],
      chunks = data.length / perPage;
    for (let i = 0, j = 0; i < chunks; i++, j += perPage)
      sets[i] = data.slice(j, j + perPage);
    return sets;
  };

  render() {
    let {
      data,
      location,
      activePage,
      pageChange,
      searchName,
      handleChange,
      loading,
      setExcursion,
    } = this.props;
    // location = ucwords(location);
    let pagedData = this.pagination(data, 3);
    let listData = pagedData[activePage - 1];
    return (
      <Container>
        <Grid>
          <Grid.Row>
            <Grid.Column width={9}>
              <Segment style={styles.segmentNoPadding}>
                <Input
                  name="searchLocation"
                  type="input"
                  icon="map marker alternate"
                  iconPosition="left"
                  inputStyles={styles.inputStyles}
                  label={`${data.length} Excursion Found`}
                  labelStyles={styles.boldGoldColor}
                  value={location}
                  disabled={true}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column width={7}>
              <Segment style={styles.segmentNoPadding}>
                <Input
                  name="searchName"
                  type="input"
                  icon="search"
                  iconPosition="left"
                  inputStyles={styles.inputStyles}
                  label="Search Name"
                  labelStyles={styles.textBold}
                  placeholder="Search by excursion name"
                  value={searchName}
                  handleChange={handleChange}
                />
              </Segment>
            </Grid.Column>
            <Grid.Column width={16}>
              <LoaderModal loading={loading} />
              {listData && !loading
                ? listData.map((data, index) => {
                    return (
                      <Card
                        key={index}
                        data={data}
                        setExcursion={setExcursion}
                      />
                    );
                  })
                : !loading && (
                    <Header textAlign="center" as="h4">
                      There is no result of excursion for your destination
                    </Header>
                  )}
            </Grid.Column>
            <Grid.Column
              textAlign="center"
              width={16}
              style={{ paddingTop: '10px' }}
            >
              {pagedData &&
                !loading &&
                pagedData.length > 1 && (
                  <Pagination
                    totalPages={pagedData.length}
                    onPageChange={pageChange}
                    activePage={activePage}
                  />
                )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default listCard;
